<template>
    <q-layout view="hHh lpR fFf">
        <q-page-container>
          <q-header>
            <q-toolbar class="pa0 bg-white">
              <div style="width:300px" class="d-flex left_section q-pl-md">
                <q-btn flat dense icon="menu" @click="drawer = !drawer" />
                <q-toolbar-title class="ft16 text">
                  <span class="ft-b">텐스에듀</span> 매뉴얼
                </q-toolbar-title>
              </div>
              <div class="border-b1 text-right text-grey text" style="flex-grow:1;padding-right:16px;">
                <q-icon name="phone" /> 031) 205-6393
              </div>
            </q-toolbar>
        </q-header>
        <q-drawer show-if-above v-model="drawer" side="left" class="left_section">
          <q-scroll-area class="fit">
            <q-list class="q-py-md">
              <q-item style="padding: 4px 0;"
                      v-for="item in menu" 
                      :key="item.title">
                <q-item-section class="q-px-none">
                  <div class="q-px-lg title">
                    {{ item.title }}
                  </div>
                  <li class="q-px-lg" 
                      v-for="sub_item in item.children" 
                      :key="sub_item.title">
                      <div class="q-px-lg pointer" @click="click_menu(sub_item)">
                        <q-icon class="px2 pb1 ft6" name="play_arrow" />
                        <span class="px2">{{ sub_item.title }}</span>
                      </div>
                  </li>
                  <div class="spacer"></div>
                </q-item-section>
              </q-item>
            </q-list>
          </q-scroll-area>
        </q-drawer>
        <q-page padding class="manual">
            <div v-if="page=='login'"><page-login /></div>
            <div v-else-if="page=='home'"><page-home /></div>
            <div v-else-if="page=='home/register'"><page-home-register /></div>
            <div v-else-if="page=='home/today'"><page-home-today /></div>
            <div v-else-if="page=='staff/class'"><page-staff-class /></div>
            <div v-else-if="page=='teacher/class'"><page-teacher-class /></div>
            <div v-else-if="page=='staff/message'"><page-staff-message /></div>
            <div v-else-if="page=='stat/student'"><page-stat-student /></div>
            <div v-else-if="page=='stat/payment'"><page-stat-payment /></div>
            <div v-else-if="page=='stat/drop_rate'"><page-stat-drop-rate /></div>
            <div v-else-if="page=='setting'"><page-setting /></div>
            <div v-else-if="page=='setting/teacher'"><page-setting-teacher /></div>
            <div v-else-if="page=='setting/permission'"><page-setting-permission /></div>

            <div v-else-if="page=='app/teacher'"><page-app-teacher /></div>
            <div v-else-if="page=='app/student'"></div>
            
            <div v-else-if="page=='setting/billing'"></div>
            <div v-else-if="page=='setting/message'"></div>
            <div v-else-if="page=='job/checkinout'"><page-job-checkinout /></div>

            <div v-else-if="page=='job/enter_schedule'"><page-job-enter-schedule /></div>
            <div v-else-if="page=='job/mission'"><page-job-mission /></div>

        </q-page>
        </q-page-container>
    </q-layout>
</template>

<script>
import pageLogin from './pages/pageLogin.vue'
import pageHome from './pages/pageHome.vue'
import pageHomeRegister from './pages/pageHomeRegister.vue'
import pageHomeToday from './pages/pageHomeToday.vue'
import pageStaffClass from './pages/pageStaffClass.vue'
import pageTeacherClass from './pages/pageTeacherClass.vue'
import pageStaffMessage from './pages/pageStaffMessage.vue'
import pageStatStudent from './pages/pageStatStudent.vue'
import pageStatPayment from './pages/pageStatPayment.vue'
import pageStatDropRate from './pages/pageStatDropRate.vue'
import pageSetting from './pages/pageSetting.vue'
import pageSettingTeacher from './pages/pageSettingTeacher.vue'
import pageSettingPermission from './pages/pageSettingPermission.vue'

import pageAppTeacher from './pages/pageAppTeacher.vue'

import pageJobEnterSchedule from './pages/pageJobEnterSchedule.vue'
import pageJobMission from './pages/pageJobMission.vue'
import pageJobCheckinout from './pages/pageJobCheckinout.vue'


export default {
    components : {
      pageLogin,
      pageHome,
      pageHomeRegister,
      pageHomeToday,

      pageStaffClass,
      pageTeacherClass,
      pageStaffMessage,
      pageStatStudent,
      pageStatPayment,
      pageStatDropRate,

      pageSetting,
      pageSettingTeacher,
      pageSettingPermission,
      
      pageAppTeacher,
      pageJobEnterSchedule,
      pageJobMission,
      pageJobCheckinout,
    },
    data : function() {
        return {
            drawer: false,
            page : 'home',
            menu: [
                { title: "시작하기",
                  children:[
                    { title: "로그인",                          page:'login' },
                    { title: "Tens에듀 홈화면",                 page:'home' },
                    { title: "홈화면의 학생등록 / 입반 / 전반", page:'home/register' },
                    { title: "홈화면의 오늘수업 / 보강",        page:'home/today' },
                    { title: "반관리",                          page:'staff/class' },
                    { title: "수업관리",                        page:'teacher/class' },
                    { title: "메시지관리",                      page:'staff/message' },
                    { title: "학생관리",                        page:'stat/student' },
                    { title: "수납관리 / 미납자관리",           page:'stat/payment' },
                    { title: "퇴원 위험도 분석",                page:'stat/drop_rate' },
                    { title: "설정",                            page:'setting' },
                    { title: "직원관리",                        page:'setting/teacher' },
                    { title: "관리자권한 / 강사권한",           page:'setting/permission' },
                    ], 
                },
                // { title: "API 설정",
                //   children:[
                //     { title: "단말기 사용하기",                 page:'setting/billing' },
                //     { title: "문자메시지 설정하기",             page:'setting/message' },
                //     ], 
                // },
                { title: "업무 프로세스",
                  children:[
                    { title: "입학관리",                        page:'job/enter_schedule' },
                    { title: "수업미션관리",                    page:'job/mission' },
                    { title: "등하원 메시지 발송",              page:'job/checkinout' },
                    ], 
                },
                { title: "앱 사용하기",
                  children:[
                    { title: "학원관리앱",                      page:'app/teacher' },
                    // { title: "학생앱",                          page:'app/student' },
                    ], 
                },
                
            ],
        }
    },
    computed :{
    },
    methods : {
      click_menu(menu) {
        this.page = menu.page;
      }
    },
    beforeMount() {
        
    }
}
</script>

<style scope>
.ft6 { font-size:6px; }
.ft8 { font-size:8px; }

.left_section {
    background-color: #192642;
    color: white;
}
.q-header .text {
    height:50px; padding:14px 10px 0;
}
.q-item .title {
    line-height: 28px;
}
.q-drawer {
  background-color: #192642;
  padding : 0 4px 0 0;
}
.q-drawer__content {
    background-color: #2D3A58;
}
.left_section li {
    display: block;
    list-style: none;
    line-height: 28px;
    padding: 0;
    color: #ddd;
}
.left_section li:hover {
    background-color: #4A5777;
    color: #fff;
}
.spacer {
    margin: 12px 0 8px;
    border-bottom: 1px solid  #192642;
}

.manual {
    line-height: 30px;
}
.manual h2 {
    display: inline-block;
    margin: 0 0 30px -20px;
    padding: 0 0 0 20px;
    font-size: 20px;
    font-weight: bold;
    line-height: 2rem;
    color: #111;
}
.manual p {
    margin: 0 0 20px;
}

.manual .section_0 {
  padding-left: 16px; 
  text-indent: -16px;
}
.manual .section_1 {
  padding-left: 16px; 
  text-indent: -8px;
}
.manual .section_2 {
  padding-left: 16px; 
  text-indent: 0px;
}
.manual .examples {
  line-height:1.5rem;
}
</style>